import { combineEpics } from 'redux-observable';
import Api from 'lib/Api';
import ReduxHelper from 'lib/ReduxHelper';
import { I18n as I } from 'react-redux-i18n';

import { MERCHANT_FEES_ACTION_TYPES as AT } from './Fees.actions';

export default combineEpics(
  ...ReduxHelper.createDefaultEpics(
    [AT.MERCHANT_FEES_FETCH_DATA, Api.fetchMerchantFeesData],
    [
      AT.MERCHANT_FEES_UPDATE_DATA,
      Api.updateMerchantFeesData,
      { successMessage: () => I.t('MERCHANT_FEE_SAVED') },
    ]
  )
);
